module.exports = __webpack_public_path__ + "img/feature-04.8980a996.png";